import getNextConfig from 'next/config'

const publicRuntimeConfig = () => getNextConfig().publicRuntimeConfig

export default publicRuntimeConfig
